import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Slider from "react-slick";

export const UpcomingWebinars = (props) => {
  const sc = props.slice.primary;

  const data = useStaticQuery(graphql`
    query upcomingWebinarsSlice {
      allPrismicResource(
        sort: { data: { date: DESC } }
        filter: {data: {resource_type: {eq: "webinar"}, hide: {eq: false}}}
      ) {
        nodes {
          _previewable
          data {
            date(formatString: "X")
            date_published: date(formatString: "MMMM DD, YYYY")
            resource_title {
              text
            }
            resource_label
            meta_image {
              gatsbyImageData
              alt
            }
            description {
              text
            }
            resource_type
          }
          url
        }
      }
    }
  `);

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

  const events = data.allPrismicResource.nodes;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "upcoming-webinars-slider",
    nextArrow: <div><i className="fa-solid fa-chevron-right text-grey text-3xl cursor-pointer" /></div>,
    prevArrow: <div><i className="fa-solid fa-chevron-left text-grey text-3xl cursor-pointer" /></div>,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  };

  var today = new Date()
  today.setHours(0,0,0,0);
  var todayValue = today.valueOf();

  // Filter for upcoming webinars only (already filtered for webinars in GraphQL)
  const upcomingWebinars = events.filter(event => {
    const eventDate = new Date(event.data.date * 1000);
    const isUpcoming = eventDate.valueOf() >= todayValue;
    
    // Debug logging (remove in production)
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
      console.log('Webinar:', event.data.resource_title?.text, {
        eventDate: eventDate.toDateString(),
        today: new Date(todayValue).toDateString(),
        isUpcoming,
        timestamp: event.data.date
      });
    }
    
    return isUpcoming;
  });

  return (
    <section className={"relative bg-" + bg + " " + space}>
      <div className="wrapper">
        {sc.section_title?.text ? (
          <div className="mb-8">
            <PrismicRichText field={sc.section_title.richText} />
          </div>
        ) : (
          <h2 className="mb-8">Upcoming webinars</h2>
        )}
    
        {upcomingWebinars.length > 0 ? (
          <Slider {...settings}>
            {upcomingWebinars.map((webinar, index) => (
              <div key={index}>
                <a 
                  className="flex flex-col md:flex-row justify-between gap-12 mb-8 items-center undefined" 
                  href={webinar.url}
                >
                  <div className="w-auto md:w-1/2 rounded-lg border border-grey-md">
                    <GatsbyImage 
                      image={getImage(webinar.data.meta_image)} 
                      alt={webinar.data.meta_image.alt || `${webinar.data.resource_title.text} graphic`} 
                      className="rounded-lg" 
                    />
                  </div>
                  <div className="w-auto md:w-1/2">
                    <div className="label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-accessible-teal">
                      {webinar.data.resource_label || webinar.data.resource_type}
                    </div>
                    <h2 className="text-3xl">{webinar.data.resource_title.text}</h2>
                    <p>{webinar.data.description.text}</p>
                    <span className="btn bg-yellow">Register now</span>
                  </div>
                </a>
              </div>
            ))}
          </Slider>
        ) : (
          <p className="text-lg flex items-center gap-4 px-5 py-2 bg-grey-light w-fit rounded-xl">
            <i className="fa-regular fa-calendar-xmark text-2xl text-red" />
            <span>No upcoming webinars at the moment.</span>
          </p>
        )}
      </div>
    </section>
  );
};

